import React from 'react';
import { Box, Typography } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

const ChatEmptyState: React.FC = () => (
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#0a0a14',
      gap: 2,
      background:
        'radial-gradient(ellipse at 50% 50%, rgba(124,77,255,0.06) 0%, transparent 70%), #0a0a14',
    }}
  >
    <Box
      sx={{
        width: 90,
        height: 90,
        borderRadius: '50%',
        background:
          'linear-gradient(135deg, rgba(124,77,255,0.15), rgba(255,64,129,0.1))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid rgba(124,77,255,0.15)',
      }}
    >
      <ChatIcon sx={{ fontSize: 40, color: '#7c4dff' }} />
    </Box>
    <Typography
      variant="h6"
      sx={{
        fontWeight: 600,
        background: 'linear-gradient(135deg, #8888a8, #7c4dff)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      ChatApp for Web
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: '#5555a0', textAlign: 'center', maxWidth: 360 }}
    >
      Send and receive messages instantly. Select a conversation or search for a
      user to start chatting.
    </Typography>
  </Box>
);

export default ChatEmptyState;
